import type { ReactNode } from "react";
import React, { useEffect, useRef, useState } from "react";

import { cn } from ".";
import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip";

interface TruncatedTooltipProps {
  children: ReactNode;
  className?: string;
  tooltipClassName?: string;
}

export const TruncatedTooltip = React.memo(
  ({
    children,
    className = "",
    tooltipClassName = "",
  }: TruncatedTooltipProps) => {
    const textRef = useRef<HTMLSpanElement>(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
      const checkTruncation = () => {
        const el = textRef.current;
        if (el) {
          setIsTruncated(el.scrollWidth > el.offsetWidth);
        }
      };

      checkTruncation();
      window.addEventListener("resize", checkTruncation);
      return () => window.removeEventListener("resize", checkTruncation);
    }, [children]);

    const content = (
      <span ref={textRef} className={cn("block truncate", className)}>
        {children}
      </span>
    );

    return isTruncated ? (
      <Tooltip>
        <TooltipTrigger asChild>{content}</TooltipTrigger>
        <TooltipContent className={cn(tooltipClassName)}>
          {children}
        </TooltipContent>
      </Tooltip>
    ) : (
      content
    );
  },
);
